import type { Point2d } from ".."
import { NANO } from "../../constants/SMALL_NUMBERS"

export const isSamePoint = (a: Point2d, b: Point2d): boolean =>
  Math.abs(a.x - b.x) < NANO && Math.abs(a.y - b.y) < NANO
